import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "TableBox",
  style: {"height":"auto"}
}
const _hoisted_2 = { class: "TableTop" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("未开始")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("进行中")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已结束")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_9 = { class: "TableTopBtn" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("开始")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("结束")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AddOrEditDialog = _resolveComponent("AddOrEditDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: _ctx.query,
          inline: "",
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
          ref: "queryFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "迭代名称：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.query.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
                  placeholder: "请输入迭代名称",
                  size: "small",
                  clearable: "",
                  onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList('place')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "迭代负责人：",
              prop: "user_type1_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.query.user_type1_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.user_type1_name) = $event)),
                  placeholder: "请输入迭代负责人",
                  size: "small",
                  clearable: "",
                  onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList('place')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "迭代时间段：",
              prop: "date_interval"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.query.date_interval,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.date_interval) = $event)),
                  "range-separator": "至",
                  type: "daterange",
                  size: "small",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  clearable: "",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getList('place')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态：",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.query.status,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.status) = $event)),
                  size: "small",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList('place'))),
                  style: {"display":"block"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getList('place')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.init()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.projectStatus !== 1 && _ctx.projectStatus !== 5 && _ctx.$globalFun.ifAuth(_ctx.$route, '迭代-新增'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                icon: "plus",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onAddOrEdit(0)))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tableListRef",
        class: "TableList",
        border: "",
        data: _ctx.list,
        "max-height": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "迭代名称",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "user_type1.username",
            label: "迭代负责人",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "start_date",
            label: "迭代开始时间",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "end_date",
            label: "迭代结束时间",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status_str",
            label: "状态",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            width: "300",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              (_ctx.$globalFun.ifAuth(_ctx.$route, '迭代-状态更改'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (scope.row.status === 1)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "mini",
                          onClick: ($event: any) => (_ctx.editStates(scope.row.id, 2))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.status === 2)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "danger",
                          size: "mini",
                          onClick: ($event: any) => (_ctx.editStates(scope.row.id, 3))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.$globalFun.ifAuth(_ctx.$route, '迭代-详情'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "mini",
                    onClick: ($event: any) => (_ctx.onAddOrEdit(2, scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$globalFun.ifAuth(_ctx.$route, '迭代-编辑'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    disabled: scope.row.status === 2 || scope.row.status === 3,
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.onAddOrEdit(1, scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$globalFun.ifAuth(_ctx.$route, '迭代-删除'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    disabled: scope.row.status === 2 || scope.row.status === 3,
                    type: "danger",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.onDel(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_el_pagination, {
        class: "TablePagination",
        background: "",
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.query.page,
        "page-sizes": [20, 40, 60, 100],
        "page-size": _ctx.query.paginate,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_AddOrEditDialog, {
      ref: "addOrEditDialogRef",
      projectId: _ctx.projectId
    }, null, 8, ["projectId"])
  ]))
}